import { Button, IconButton, Typography } from '@mui/material';
import { athleteDisplayName, AthletePreview } from '@strength/domain';
import { MdMenu } from '@teamworksdev/icons';
import { useState } from 'react';
import { AthleteAvatar } from '../../../../components/icons/athlete-avatar';
import { cn } from '../../../../components/utils';
import { tabletAvatarStyle } from '../../utils';

export const MenuBar = ({
  athletes,
  setSelectedAthleteId,
}: {
  athletes: AthletePreview[];
  setSelectedAthleteId: (athleteId: string) => void;
}) => {
  const [menuOpen, setMenuOpen] = useState(true);

  return (
    <div
      className={cn(
        'pt-2 from-green-600 bg-gradient-to-t to-black to-20% flex flex-col align-middle h-full gap-2 p-4',
        menuOpen ? 'justify-start' : 'items-center',
      )}
    >
      <div
        className={`flex flex-row flex-shrink-0 ${
          menuOpen ? 'justify-start' : ''
        }`}
      >
        <IconButton onClick={() => setMenuOpen(!menuOpen)} className="p-1">
          <MdMenu className="text-white" size={24} />
        </IconButton>
      </div>

      <div
        className={cn(
          'flex-1 min-h-0 overflow-y-auto flex flex-col items-start',
          '[&::-webkit-scrollbar-thumb]:bg-white/15 [&::-webkit-scrollbar-thumb]:rounded-2xl',
          menuOpen
            ? '[&::-webkit-scrollbar]:w-3 [scrollbar-color:rgba(255,255,255,0.15)_transparent] [scrollbar-width:thin]'
            : '[&::-webkit-scrollbar]:w-0 [scrollbar-width:none]',
        )}
      >
        {athletes.map((athlete) => {
          return menuOpen ? (
            <Button
              variant="text"
              key={athlete.id}
              type="button"
              className="flex flex-row items-center justify-start gap-2 mt-4 cursor-pointer bg-transparent border-none p-0 text-left flex-shrink-0"
              onClick={() => setSelectedAthleteId(athlete.id)}
            >
              <AthleteAvatar athlete={athlete} sx={tabletAvatarStyle} />
              <Typography color="white" variant="body1Semibold">
                {athleteDisplayName(athlete)}
              </Typography>
            </Button>
          ) : (
            <Button
              variant="text"
              key={athlete.id}
              type="button"
              className="mt-4 cursor-pointer bg-transparent border-none p-0 flex-shrink-0"
              aria-label={athleteDisplayName(athlete)}
              onClick={() => setSelectedAthleteId(athlete.id)}
            >
              <AthleteAvatar athlete={athlete} sx={tabletAvatarStyle} />
            </Button>
          );
        })}
      </div>
    </div>
  );
};
